export const defaultVotingTile = ['0.5', '1', '2', '3', '5', '8', '13', '20', '40', '100', '?'];